import React from 'react'

import { Button } from '@wartek-id/button'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog'
import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'
import { useToast } from '@wartek-id/toast'

import { useAPIResetKSSelections } from 'api/selection/useAPISelection'

import { useRegionContext } from 'utils/hooks/useRegion'

export const isResetDataEnabled =
  process.env.NEXT_PUBLIC_RESET_DATA_ENABLED === 'true'

interface ResetDataButtonProps {
  onClick: () => void
}

const ResetDataButton = ({ onClick }: ResetDataButtonProps) => {
  return (
    <Button
      color="red"
      fullWidth
      className="mb-2"
      data-testid="btn-reset-data"
      onClick={onClick}
    >
      <Icon fontSize="sm" color="inverse" className="mr-1">
        delete
      </Icon>
      Reset Data
    </Button>
  )
}

interface ResetDataDialogProps {
  isOpen: boolean
  onClose: () => void
}

export const ResetDataDialog = ({ isOpen, onClose }: ResetDataDialogProps) => {
  const toast = useToast()
  const { regionDetail } = useRegionContext()

  const { mutate: resetData, isLoading } = useAPIResetKSSelections({
    regionId: regionDetail.id,
    regionType: regionDetail.type,
  })

  const regionName = regionDetail.name || '-'

  const handleConfirm = () => {
    resetData(undefined, {
      onSuccess() {
        toast({
          message: `Berhasil menghapus seluruh data seleksi KS untuk wilayah ${regionName}.`,
        })
        onClose()
      },
      onError() {
        toast({
          message: 'Gagal menghapus data seleksi KS. Coba lagi.',
        })
        onClose()
      },
    })
  }

  return (
    <Dialog isOpen={isOpen} onClose={onClose} size="sm">
      <DialogOverlay />
      <DialogContent data-testid="dialog-reset-data">
        <div className="p-6">
          <Text variant="display-sm">Reset data seleksi KS?</Text>
          <Text color="subdued" className="mt-2">
            Seluruh data seleksi KS untuk wilayah <strong>{regionName}</strong>{' '}
            akan dihapus permanen. Tindakan ini tidak dapat dibatalkan. Tetap
            reset?
          </Text>

          <div className="mt-6 flex gap-3">
            <Button
              size="lg"
              color="red"
              data-testid="btn-confirm-reset"
              isLoading={isLoading}
              disabled={isLoading}
              onClick={handleConfirm}
            >
              Ya, reset
            </Button>
            <Button
              size="lg"
              color="white"
              data-testid="btn-cancel-reset"
              isLoading={isLoading}
              disabled={isLoading}
              onClick={onClose}
            >
              Batalkan
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ResetDataButton
